export function setPrimaryColor(color: string) {
  const root = document.documentElement;
  root.style.setProperty('--color-theme-primary', `#${color}`);
}

export function setPrimaryColorOpaque(color: string) {
  const root = document.documentElement;
  root.style.setProperty('--color-theme-primary-opaque', `#${color}`);
}

export function setSecondaryColor(color: string) {
  const root = document.documentElement;
  root.style.setProperty('--color-theme-secondary', `#${color}`);
}

export const hexTransparencies: string[] = [
  '00',
  '03',
  '05',
  '08',
  '0A',
  '0D',
  '0F',
  '12',
  '14',
  '17',
  '1A',
  '1C',
  '1F',
  '21',
  '24',
  '26',
  '29',
  '2B',
  '2E',
  '30',
  '33',
  '36',
  '38',
  '3B',
  '3D',
  '40',
  '42',
  '45',
  '47',
  '4A',
  '4D',
  '4F',
  '52',
  '54',
  '57',
  '59',
  '5C',
  '5E',
  '61',
  '63',
  '66',
  '69',
  '6B',
  '6E',
  '70',
  '73',
  '75',
  '78',
  '7A',
  '7D',
  '80',
  '82',
  '85',
  '87',
  '8A',
  '8C',
  '8F',
  '91',
  '94',
  '96',
  '99',
  '9C',
  '9E',
  'A1',
  'A3',
  'A6',
  'A8',
  'AB',
  'AD',
  'B0',
  'B3',
  'B5',
  'B8',
  'BA',
  'BD',
  'BF',
  'C2',
  'C4',
  'C7',
  'C9',
  'CC',
  'CF',
  'D1',
  'D4',
  'D6',
  'D9',
  'DB',
  'DE',
  'E0',
  'E3',
  'E6',
  'E8',
  'EB',
  'ED',
  'F0',
  'F2',
  'F5',
  'F7',
  'FA',
  'FC',
  'FF',
];

export function getHexWithOpacity(hex: string, opacity: number) {
  if (opacity >= 1) {
    return `${hex}${hexTransparencies[100]}`;
  }

  if (opacity <= 0) {
    return `${hex}${hexTransparencies[0]}`;
  }

  const opacityString = opacity.toString().substring(2, 4).padEnd(2, '0');
  const opacityIndex = parseInt(opacityString, 10);

  return `${hex}${hexTransparencies[opacityIndex]}`;
}

export function hexToRGB(hex: string) {
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return { r, g, b };
}
